/**
 * Raknida News — sanitize article body HTML.
 * Some migrated posts still contain a full BeYours article page dump
 * (.page-width--inner, .article-template, nested shopify-section, etc.).
 * Those theme chrome classes add huge side padding / max-widths and make
 * the reading column look broken inside .rk-art-body.
 */
(function (global) {
  'use strict';

  var CHROME =
    'header.page-width, .page-width, .page-width--inner, .page-width--narrow,' +
    '.page-width-desktop, .transition-body, .transition-content,' +
    '.shopify-section, .section, .section--padding,' +
    'article.article-template, .article-template, .article-template__content';

  function unwrap(el) {
    var parent = el.parentNode;
    if (!parent) return;
    while (el.firstChild) parent.insertBefore(el.firstChild, el);
    parent.removeChild(el);
  }

  function sanitizeNewsBody(root) {
    if (!root || root.dataset.rkSanitized === '1') return root;
    root.dataset.rkSanitized = '1';

    /* Prefer the deepest pasted RTE / article content container */
    var preferred =
      root.querySelector('.article-template__content') ||
      root.querySelector('.rte.page-width') ||
      root.querySelector('.rte');
    if (
      preferred &&
      preferred !== root &&
      root.contains(preferred) &&
      (preferred.textContent || '').trim().length > 40
    ) {
      var frag = document.createDocumentFragment();
      while (preferred.firstChild) frag.appendChild(preferred.firstChild);
      root.textContent = '';
      root.appendChild(frag);
    }

    var guard = 0;
    while (guard++ < 30) {
      var el = root.querySelector(CHROME);
      if (!el || el === root) break;
      unwrap(el);
    }

    root.querySelectorAll('header').forEach(function (h) {
      if (!(h.textContent || '').trim()) h.remove();
    });

    root.querySelectorAll('[style]').forEach(function (el) {
      el.removeAttribute('style');
    });
    root.querySelectorAll('[align]').forEach(function (el) {
      el.removeAttribute('align');
    });
    root.querySelectorAll('[width],[height]').forEach(function (el) {
      if (el.tagName === 'IMG' || el.tagName === 'SVG') return;
      el.removeAttribute('width');
      el.removeAttribute('height');
    });

    root.querySelectorAll('table').forEach(function (table) {
      var cells = table.querySelectorAll('td,th');
      if (!cells.length) {
        table.remove();
        return;
      }
      var f = document.createDocumentFragment();
      cells.forEach(function (cell) {
        while (cell.firstChild) f.appendChild(cell.firstChild);
      });
      if (table.parentNode) table.parentNode.insertBefore(f, table);
      table.remove();
    });

    root.querySelectorAll('center,font').forEach(function (el) {
      unwrap(el);
    });

    return root;
  }

  global.rkSanitizeNewsBody = sanitizeNewsBody;
})(typeof window !== 'undefined' ? window : this);
